var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalthanks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 80C18.522 80 0.5 61.8785 0.5 40.221C0.5 18.5635 18.522 0 40.0604 0C53.2472 0 65.5549 6.62983 73.0275 17.2376C73.467 18.1215 73.9066 19.0055 73.467 19.8895C73.467 20.3315 73.0275 20.7735 73.0275 20.7735L40.5 60.1105C40.0604 60.5525 39.1813 60.9945 38.3022 60.9945C37.4231 60.9945 36.544 60.5525 36.1044 60.1105L16.3242 42.4309L20.2802 38.0111L37.4231 54.3646L66.8736 19.0055C60.2802 11.0497 50.6099 6.18785 40.5 6.18785C21.5989 6.18785 6.65385 21.2155 6.65385 40.221C6.65385 59.2265 22.0385 74.2542 40.5 74.2542C58.9615 74.2542 74.3462 58.7845 74.3462 40.221C74.3462 37.1271 73.9066 33.5912 73.0275 30.4972L78.7418 28.7293C79.6209 32.2652 80.5 36.2431 80.5 40.221C80.0604 62.3204 62.478 80 40.5 80Z",
    fill: "#00855D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalthanks);
export default __webpack_public_path__ + "static/media/finalthanks.ddd21eb63b5a2105de05c2c49bf0d50b.svg";
export { ForwardRef as ReactComponent };